import { c as _c } from "react/compiler-runtime";
import Spinner from '@/components/Spinner/Spinner';
const FullPageSpinner = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex h-screen w-screen flex-col items-center justify-center bg-greyscale-950" data-testid="loading-placeholder"><Spinner size="large" theme="dark" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default FullPageSpinner;